module.exports = {
    en: {
        open: 'open',
        hide: 'hide',
        ago: 'ago',
        aYear: 'a year ago',
        aMonth: 'a month ago',
        months: 'months',
        aWeek: 'a week ago',
        week: 'weeks',
        hour: 'an hour ago',
        hours: 'hours',
        minute: '1 minute ago',
        minutes: 'minutes',
        day: 'a day ago',
        days: 'days',
        yesterday: 'Yesterday',
        today: 'Today',
        justNow: 'just now',
        vote: 'Vote',
        voted: 'voted',
        voteSub: 'Vote Submitted',
        voteFail: 'Vote failed, please retry~',
        submit: 'Submit',
        matchVoted: 'You have already voted~',
        thanksVote: 'Thanks for voting',
        voteOver: 'Voting is over',
        comments: 'Comments',
        addComment: 'Add a comment',
        readMore: 'Read more comments',
        noCommented: 'No one has commented yet',
        likedAlready: "You've liked it already",
        reply: 'Reply',
        related: 'Related',
        Copyright: 'Copyright Declaration',
        mayLike: 'You may like',
        aOption: 'option most',
        options: 'options most',
        downloadForComments: 'Download All Football for more comments',
        // downloadCoin
        bestApp: 'The Best App for Football Fans',
        downloadForCoin: 'Top-notch tips & predictions from the most experienced experts, fastest & most accurate data on the hottest matches -- Download now!',
        download: 'Download',
        shareForCoin: 'STRONGLY recommend this amazing football app to you!',
        copy: 'Copy',
        copySuccess: 'Copy successfully',
        AboutUserPosts: 'About User Posts',
        Report: 'Report',
        Follow: 'Follow',
        Following: 'Following',
        bonus: 'Bonus',// 答题的分享页
        startTime: 'Start time',
        inviteOther: 'Invite others to participate in the game, you will get resurrection cards',
        invite: 'Invite',
        rules: 'Game Rules',
        goAnswer: 'Go answering',
        leasePogin: 'Please login to participate in the answer',
        share: 'Enter the invitation code, your friend and you will both get a resurrection card.',
        shareBouns: 'I got bonus in All Football',
        shareComm: 'Answer all 12 questions to share the big prize',
        login: 'Login',
        enterInv: 'Enter invitation code',
        inviteFriend: 'Invite others to get extra lives',
        receiveDuration1: 'Please enter your Paypal account.',
        receiveDuration2: 'We will give you a bonus within 1week.',
        receiveConfirm: 'Confirm',
        receiveSubmited: 'Your information has been submited',
        receiveExpired: 'The page has expired',
        gotCard: 'You got a resurrection card',
        title: 'Super Football Hero',
        timeLeft: 'Time left',
        copied: 'Copied',
        copyFailed: 'Copy failed, please retry'
    },
    zh_cn: {
        open: '打开',
        hide: '隐藏',
        aYear: '一年前',
        aMonth: '一个月前',
        months: '月前',
        aWeek: '一周前',
        week: '周',
        hour: '时前',
        hours: '时前',
        minute: '分前',
        minutes: '分前',
        day: '天前',
        days: '天前',
        yesterday: '昨天',
        today: '今天',
        justNow: '现在',
        vote: '投票',
        voted: '已投',
        voteFail: '投票失败，请重试~',
        submit: '提交',
        matchVoted: '你已经投过票了~',
        thanksVote: '感谢投票~',
        voteOver: '投票已结束~',
        comments: '评论',
        addComment: '写个评论',
        readMore: '看更多评论',
        noCommented: '没有人评论过',
        likedAlready: '你已经点赞过了',
        reply: '回复',
        related: '相关',
        Copyright: '版权声明',
        mayLike: '猜你喜欢',
        aOption: 'option most',
        options: 'options most',
        AboutUserPosts: 'About User Posts',
        Report: 'Report',
        Follow: 'Follow',
        Following: 'Following'

    },
    es: {
        open: 'abrir',
        hide: 'esconder',
        ago: 'hace',
        aYear: 'hace un año',
        aMonth: 'hace un mes',
        months: 'meses',
        aWeek: 'hace una semana',
        week: 'semanas',
        hour: 'hace una hora',
        hours: 'horas',
        minute: 'hace un minuto',
        minutes: 'minutos',
        day: 'hace un día',
        days: 'días',
        yesterday: 'ayer',
        today: 'hoy',
        justNow: 'Ahora mismo',
        vote: 'votar',
        voted: 'votado',
        voteSub: 'Voto Emitido',
        voteFail: 'La votación no funcionó, vuelve a intentarlo~',
        submit: 'someter',
        matchVoted: 'Ya has votado~',
        thanksVote: 'Gracias por votar',
        voteOver: 'La votación termina',
        comments: 'Comentarios',
        addComment: 'Comenta',
        readMore: 'Mas comentarios',
        noCommented: 'Nadie ha comentado todavía',
        likedAlready: 'Ya lo has gustado',
        reply: 'Responder',
        related: 'Relacionado',
        Copyright: 'Declaración de Copyright',
        mayLike: 'Te podría interesar',
        aOption: 'opción al máximo',
        options: 'opciones al máximo',
        downloadForComments: 'Descargue All Football para más comentarios',
        // downloadCoin
        bestApp: 'La mejor app para los fanáticos del fútbol',
        downloadForCoin: 'Después de instalar la app, indique el código de invitación. El invitador se ganará 30 puntos de AF',
        download: 'Descargar',
        shareForCoin: 'Recomiendo fuertemente esta fantástica aplicación de fútbol!',
        copy: 'Copiar',
        copySuccess: 'Copiar con éxito',
        AboutUserPosts: 'Denunciar Posts de usuarios',
        Report: 'Sobre',
        Follow: 'Seguir',
        Following: 'Siguiendo',
        title: '¡Trae dinero a casa! Ven a responder a las preguntas y ganar dinero', // 答题的分享页
        timeLeft: 'Tiempo restante'
    },
    vi: {
        downloadForCoin: 'Cập nhật thông tin tức thời , Dự đoán tỷ số và phân tích trận đấu chuyên nghiệp',
        bestApp: 'Ứng dụng tuyệt vời nhất dành cho fans bóng đá',
        copy: 'Sao chép',
        download: 'Tải về ngay thôi!!'
    }
};



// WEBPACK FOOTER //
// ./src/lang/index.js